import React from 'react';
import qs from 'qs';

export function LoginCallback() {
  return (
    <h2>
      Logging in...
    </h2>
  );
}

export function LoginError(props) {
  const query = qs.parse(props.location.search.slice(1));

  return (
    <div>
      {query.errorDescription && <p>{query.errorDescription}</p>}
    </div>
  );
}
